/**
 * letterFormTypes.ts — kształt stanu nagłówka Pisma + pusty formularz (R3,
 * silnik formatek; mirror `purchaseInvoiceFormTypes.ts` / `saleInvoiceFormTypes.ts`).
 *
 * Wydzielone z `LetterDataTab` (dziś martwy po migracji na descent — usuwany
 * osobno): typ i stała są WSPÓLNE dla configu silnika (`letterEngineConfig.ts`),
 * rendererów pól core (`letterCoreRenderers.tsx`) i strony (`LetterDetail.tsx`),
 * a nie mogą już mieszkać w komponencie przeznaczonym do skasowania.
 *
 * `systemNumber` doszedł przy R3 (ujednolicenie — decyzja Alexandra): pismo
 * pokazuje teraz numer systemowy na zakładce „Dane" (read-only, placeholder w
 * create — dokładnie jak commercial/internal/umowy/faktury). Numer jest polem
 * WYŁĄCZNIE do odczytu (backend go generuje), stan trzyma go tylko po to, by
 * `letterSystemNumberRenderer` miał skąd wziąć wartość w trybie view/edit.
 */

export interface LetterFormData {
  title: string | null;
  status: string;
  urgency: string;
  description: string | null;
  notes: string | null;
  documentDate: string | null;
  source: string;
  externalId: string | null;
  externalSource: string | null;
  rejectionReason: string | null;
  ownerUserId: string | null;
  /** Kategoria dokumentu (oś `record_categories`, kartoteka_key='documents'). Jedna, opcjonalna. */
  categoryId: string | null;
  /** Read-only, auto-generowany przez backend — patrz nagłówek pliku. */
  systemNumber: string | null;
  documentTypeId?: string | null;
}

export const EMPTY_LETTER_FORM: LetterFormData = {
  title: null,
  status: 'draft',
  urgency: 'normal',
  description: null,
  notes: null,
  documentDate: null,
  source: 'manual',
  externalId: null,
  externalSource: null,
  rejectionReason: null,
  ownerUserId: null,
  categoryId: null,
  systemNumber: null,
  documentTypeId: null,
};
